import _uniqBy from 'lodash.uniqby';

export default {
	MENU_OPEN_CHANGE_STATE(state){
		state.mainNaviIsOpen = !state.mainNaviIsOpen
	},
	STORE_TAXONOMY_DATA(state, payload){
		state.taxonomies[payload.taxonomy] = payload.data
	},
	SEARCH_MODAL_CHANGE_STATE(state){
		state.searchModalOpen = !state.searchModalOpen
	},
	SEARCH_VALUE_CHANGE(state, payload){
		state.searchValue = payload
	},
	SET_LOADED_TAXONOMIES(state){
		state.taxonomiesLoaded = true;
	},
    STORE_PAGE_DATA(state, payload) {
        if (payload && payload[0]) {
            payload.forEach(post => {
				let postType = (post.type) ? post.type : 'undefined';
				if (!state.postsData[postType]) state.postsData = { ...state.postsData, ...{ [postType]: [] } };
				if (state.postsData[postType]) {
					// replace freshly laoded page if it is same as previous one, eg after enter password
					state.postsData[postType].filter((item, key) => {
						if (post.id === item.id) {
							state.postsData[postType][key] = post
						}
					})
				}
				state.postsData[postType].push(post);
				let filtered = _uniqBy(state.postsData[postType], 'id');
				//update meta ... 
				if (filtered) state.postsData[postType] = filtered;
			});
			//filtered = _orderby(filtered, 'date', 'desc');
		} 
    },

    STORE_PAGE_MENU(state, payload){
        if(payload && payload.items && payload.location){
            state.menus[payload.location] = payload.items
        }
    }
}